// extracted by mini-css-extract-plugin
export default {"rotator":"g3HKT9U2qlbh8AokYusV","options":"t7IJYuwq8GjuwSKdcL0w","spin":"p0937AurTfeNnlfa4T44","rotate-up":"SU3jBwdsTRG4jwGRUiVw"};